import { render, staticRenderFns } from "./ExceptionRegistrationForm.vue?vue&type=template&id=00c45ca4&"
import script from "./ExceptionRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ExceptionRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports